<template>
    <div class="page-container" :class="{ collapsed: !$store.getters.sidebarOpened }">
        <div class="area-container left-area">
            <CommonTree
                ref="faculty_tree"
                type="room"
                :showFilter="true"
                @change="handleNodeClick"
                :customStyle="{ height: 'calc(100vh - 158px)', borderRight: 'none', width: '100%' }"
            />
        </div>
        <div class="data-container center-area">
            <div class="tool-box">
                <el-button type="primary" :icon="Refresh" @click="resetQueryForm">刷新</el-button>
                <el-button type="primary" :icon="Plus" plain @click="onAddClick()">添加</el-button>
                <el-button type="success" :icon="Upload" plain @click="importsVisible = true">导入</el-button>
            </div>
            <el-form class="search-form" ref="search_form" :inline="true" :model="search_params" label-position="top">
                <el-form-item label="IMEI" prop="IMEI">
                    <el-input style="width: 165px" placeholder="请输入IMEI" v-model="search_params.IMEI" clearable />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :icon="Search" plain @click="getTableData">搜索</el-button>
                    <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table
                class="data-table"
                :data="table_data"
                v-loading="tableLoading"
                @selection-change="handleSelectionChange"
                scrollbar-always-on
            >
                <!-- <el-table-column type="selection" width="55" align="center"></el-table-column> -->
                <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
                <el-table-column label="名称" prop="name" show-overflow-tooltip></el-table-column>
                <el-table-column label="IMEI" prop="IMEI" show-overflow-tooltip></el-table-column>
                <el-table-column label="温控器组" prop="group_name" show-overflow-tooltip></el-table-column>
                <el-table-column label="安装位置" prop="location" show-overflow-tooltip></el-table-column>
                <!-- <el-table-column label="创建时间" prop="create_time" align="center" show-overflow-tooltip></el-table-column> -->
                <el-table-column label="操作" fixed="right" width="230">
                    <template #default="{ row }">
                        <el-button type="primary" link :icon="Edit" @click="onEditClick(row)">编辑</el-button>
                        <el-button type="primary" :icon="Delete" link @click="onRemoveClick(row.id)">删除</el-button>
                        <el-button type="primary" :icon="Delete" link @click="onRecordClick(row)">历史数据</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination
                v-if="table_data.length > 0"
                :current-page="page_params.page"
                :page-size="page_params.page_size"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            />
            <IrDetectionForm ref="formRef" @success="handleCurrentChange(1)" />
            <ImportsForm v-model="importsVisible" @updateForm="getTableData" menuCode="HVAC/ir_detection" />
            <RecordDialog v-model="recordVisible" :deviceDetail="deviceDetail" />
        </div>
    </div>
</template>

<script setup>
import { onMounted, reactive, ref, nextTick } from 'vue'
import { Delete, Edit, Plus, Refresh, Search, Upload } from '@element-plus/icons'
import { getIrDetectionList, deleteIrDetection } from '@/api/thermostat/ir_detection'
import IrDetectionForm from './components/form.vue'
import ImportsForm from '@/components/ImportsForm.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import Pagination from '@/components/Pagination/index.vue'
import CommonTree from '@/components/BuildTree/CommonTree.vue'
import { getOptionTree } from '@/api/room.js'
import RecordDialog from './components/RecordDialog.vue'

// 状态列表
const run_statusList = [
    { name: '在线', value: 1 },
    { name: '离线', value: 0 }
]

// 安装位置
const room_list = ref({})
async function getRoomTree() {
    const room_locations = {}
    function getRoom(list, location) {
        list.forEach((item) => {
            if (item.children) {
                getRoom(item.children, location + '/' + item.name)
            } else {
                room_locations[item.id] = location.slice(1) + '/' + item.name
            }
        })
    }
    await getOptionTree().then((data) => {
        getRoom(data ? data?.[0]?.children : [], '')
        room_list.value = room_locations
    })
}

// 左侧区域树
const faculty_tree = ref(null)
const current_node = ref({})

// 树加载完成后，默认选中第一个节点的最后一个子节点
const handleTreeLoaded = (treeData) => {
    if (!treeData || treeData.length === 0) return
    const firstNode = treeData[0]
    if (firstNode?.children?.length > 0) {
        const lastChild = firstNode.children[firstNode.children.length - 1]
        nextTick(() => {
            if (faculty_tree.value?.treeRef) {
                faculty_tree.value.treeRef.setCurrentKey(lastChild.id)
                handleNodeClick(lastChild)
            }
        })
    } else {
        nextTick(() => {
            if (faculty_tree.value?.treeRef) {
                faculty_tree.value.treeRef.setCurrentKey(firstNode.id)
                handleNodeClick(firstNode)
            }
        })
    }
}

const handleNodeClick = (data) => {
    current_node.value = data
    resetQueryForm()
}

// 搜索表单
const search_form = ref(null)
const search_params = reactive({
    name: '',
    IMEI: '',
    online: null
})

// 重置
const resetQueryForm = () => {
    if (search_form.value) {
        search_form.value.resetFields()
    }
    page_params.page = 1
    getTableData()
}

const table_data = ref([])
const tableLoading = ref(true)
const total = ref(0)
const importsVisible = ref(false)

// 获取列表数据
async function getTableData() {
    if (!current_node.value?.id) {
        table_data.value = []
        total.value = 0
        // tableLoading.value = false
        // return
    }

    tableLoading.value = true
    const params = {
        ...search_params,
        ...page_params,
        building: current_node.value.room_type ? current_node.value.pid : current_node.value.id,
        room: current_node.value?.room_type ? current_node.value.id : ''
    }
    try {
        const res = await getIrDetectionList(params)
        table_data.value = res?.lists || []
        total.value = res?.total || 0
        tableLoading.value = false
    } catch (err) {
        console.log(err)
        tableLoading.value = false
    }
}

// 分页相关
const page_params = reactive({
    page: 1,
    page_size: 10
})
const handleSizeChange = (currentSize) => {
    page_params.page_size = currentSize
    page_params.page = 1
    getTableData()
}
const handleCurrentChange = (currentPage) => {
    page_params.page = currentPage
    getTableData()
}

// 表格多选
const selected_ids = ref([])
function handleSelectionChange(list) {
    selected_ids.value = list.map((item) => item.id)
}

const formRef = ref(null)

// 添加
const onAddClick = () => {
    const params = {
        building: '',
        room: ''
    }
    if (current_node.value?.id) {
        if (current_node.value?.room_type) {
            params.room = current_node.value.id
            params.building = current_node.value.pid
        } else {
            params.building = current_node.value.id
        }
    }
    formRef.value.open(params)
}

// 编辑
const onEditClick = (row) => {
    formRef.value.open(row)
}

// 删除
function onRemoveClick(id) {
    if (!id) {
        ElMessage.error('缺少设备ID，无法删除')
        return
    }
    ElMessageBox.confirm('是否确认删除该红外探测设备？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(() => {
            deleteIrDetection(id)
                .then(() => {
                    ElMessage.success('删除成功')
                    getTableData()
                })
                .catch((err) => {
                    console.log(err)
                    ElMessage.error('删除失败')
                })
        })
        .catch(() => {})
}
const deviceDetail = ref({})
const recordVisible = ref(false)
const onRecordClick = (row) => {
    recordVisible.value = true
    deviceDetail.value = row
}

onMounted(() => {
    getTableData()
})
</script>

<style scoped>
.page-container {
    display: flex;
    height: 100%;
}
.area-container {
    flex-shrink: 0;
}
.left-area {
    width: 260px;
    border-right: 1px solid #e4e7ed;
}
.center-area {
    flex: 1;
    padding: 16px;
    overflow: auto;
}
.tool-box {
    margin-bottom: 16px;
}
.search-form {
    margin-bottom: 16px;
}
.data-table {
    margin-bottom: 16px;
}
</style>
